import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import AsyncSelect from 'react-select/async';
import { Dropdown } from '@mui/base/Dropdown';
import { MenuButton } from '@mui/base/MenuButton';
import { Menu } from '@mui/base/Menu';
import { MenuItem } from '@mui/base/MenuItem';
import { ThemeContext } from './ThemeContext';
import DocumentFinal from './DocumentFinal';
import CreateClosingDocument from './CreateClosingDocument';

export default class ClosingDocument extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            ids: [],
            items1: [],
            items2: [],
            draggedItem: null,
            sourceList: null,
            searchTerm: '',
            accounts: [],
            closingAccount: null,
            activeTab: 'closing-document'

        };
        this.TemporaryAccountClosingDocument = this.TemporaryAccountClosingDocument.bind(this);
        this.exploreTemporaryAccount = this.exploreTemporaryAccount.bind(this);
    }

    static contextType = ThemeContext;

    componentDidMount() {
        this.exploreTemporaryAccount()
    }

    handleTabClick = (tabName) => {
        this.setState({ activeTab: tabName });
    };

    TemporaryAccountClosingDocument() {
        this.httpPost("api/v1/document/TemporaryAccountClosingDocument", {
            companyId: (this.isNull(this.state.data.global.company) ? null : this.state.data.global.company.id),
            items2: this.state.items2,
            closingAccount : this.state.closingAccount
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ثبت شد");

                    this.state.data.document = data.document;

                    this.setState({ data: this.state.data });
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }

    RemoveDocument(id) {
        this.httpPost("api/v1/document/remove", {
            source: 1,
            id: id,
            companyId: (this.isNull(this.state.data.global.company) ? null : this.state.data.global.company.id),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت حذف گردید");
                    this.state.data.document = null;
                    this.setState({ data: this.state.data });
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }


    exploreTemporaryAccount() {
        this.setState({
            items1: [], items2: []
        }, () => {

            this.httpPost("api/v1/document/exploreTemporaryAccount", {
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage(data.message);
                    this.setState({
                        items1: data.records,
                        data: data,
                        loading: false
                    });
                }
                else {
                    this.showErorrMessage(data.message);
                }
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد. لطفا مجدد تلاش نمایید.");
            });
        });
    }

    handleInputChange = (newValue) => {
        const inputValue = newValue ? newValue : ''; // تنظیم مقدار پیش‌فرض در صورت undefined بودن newValue
        this.setState({ searchTerm: inputValue });
        return inputValue;
    }
    handleSelectChange = (selectedOption) => {
        this.setState({
            closingAccount: {
                fullCode: selectedOption.value,
                title: selectedOption.label.props.children[2].props.children
            }
        });
    }

    loadAccountOptions = (inputValue, callback) => {
        const companyId = this.state.data.global.company.id;
        setTimeout(() => {
            fetch("/api/v1/common/getaccounts/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    "type": 3, // نوع حساب معین 
                    "parentCode": 0,
                    companyId,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        items = response.records.map(_record => ({
                            value: _record.fullCode,
                            label: (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span style={{ fontWeight: 'bold', margin: '0 5px', lineHeight: '30px' }}>{_record.fullCode}</span>
                                    <i className="bi bi-caret-left me-2"></i>
                                    <span>{_record.title}</span>
                                </div>
                            )
                        }));
                    }
                    callback(items); // فراخوانی callback با داده‌ها
                });
        }, 50);
    }




    onDragStart = (event, item, sourceList) => {
        this.setState({ draggedItem: item, sourceList });
        event.dataTransfer.effectAllowed = 'move';
    }
    onDrop = (targetList) => {
        const { draggedItem, sourceList } = this.state;

        if (sourceList === targetList) {
            return;
        }

        this.setState(prevState => {
            let newSourceList = [...prevState[sourceList]];
            let newTargetList = [...prevState[targetList]];

            newSourceList = newSourceList.filter(i => i !== draggedItem);
            newTargetList.push(draggedItem);

            return {
                [sourceList]: newSourceList,
                [targetList]: newTargetList,
                draggedItem: null,
                sourceList: null
            };
        });
    }
    onDragOver = (event) => {
        event.preventDefault();
    }
    renderList = (items, listName) => {
        return items.map((item, index) => (
            <li
                key={index}
                draggable
                onDragStart={(event) => this.onDragStart(event, item, listName)}
                style={{ padding: '8px', margin: '4px', border: '1px solid #ccc', cursor: 'move' }}
            >
                <div>{item.fullCode} - {item.title} </div>
            </li>
        ));
    }
    transferItems = () => {
        this.setState(prevState => ({
            items2: [...prevState.items2, ...prevState.items1],
            items1: []
        }));
    }
    transferItemsBack = () => {
        this.setState(prevState => ({
            items1: [...prevState.items1, ...prevState.items2],
            items2: []
        }));
    }


    renderForm() {
        const { activeTab } = this.state;
        const { theme } = this.context;
        console.log(this.state)
        return <div>
            <div className="nk-content-body">

                <div className={`card card-bordered card-preview ${theme}`}>
                    <ul className="nav nav-tabs mt-n8 ms-3 me-3 mb-3">
                        <li className="nav-item">
                            <a
                                className={`nav-link ${activeTab === 'closing-document' ? 'active' : ''}`}
                                onClick={() => this.handleTabClick('closing-document')}
                            >
                                <em className="icon ni ni-list-round"></em>
                                <span>بستن حساب های موقت </span>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className={`nav-link ${activeTab === 'document-final' ? 'active' : ''}`}
                                onClick={() => this.handleTabClick('document-final')}
                            >
                                <em className="icon ni ni-list-round"></em>
                                <span>دائمی کردن اسناد</span>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className={`nav-link ${activeTab === 'document-close-annual' ? 'active' : ''}`}
                                onClick={() => this.handleTabClick('document-close-annual')}
                            >
                                <em className="icon ni ni-list-round"></em>
                                <span>صدور سند اختتامیه و افتتاحیه</span>
                            </a>
                        </li>
                    </ul>

                    {activeTab === 'closing-document' && <div >
                        <div className="card-inner d-flex flex-column h-100">
                            <div className="card-title-group pb-1 g-2 chart-title-bg">
                                <div className="card-title me-1">
                                    <h6 className="title">عملیات بستن حساب های موقت</h6>
                                    <p>با توجه به سند های ثبت شده در دوره جاری حساب های موقت را فراخوانی کنید و اقدام به صدور بستن حساب ها به حساب سود و زیان جاری نمائید</p>
                                </div>
                                <div className="nk-block-head-content">
                                    <div className="toggle-wrap nk-block-tools-toggle">
                                        <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                        <div className="toggle-expand-content" data-content="pageMenu">
                                            {!this.isNull(this.state.data.document) ?
                                                (
                                                    <Dropdown className="me-2">
                                                        <MenuButton className="btn btn-primary me-2">
                                                            <span>سند شماره {this.state.data.document.number}</span><em className="icon ni ni-chevron-down"></em>
                                                        </MenuButton>

                                                        <Menu className="link-list-plain">

                                                            <MenuItem>
                                                                <NavLink to={"/document/edit/" + this.state.data.document.id}>مشاهده سند</NavLink>
                                                            </MenuItem>

                                                            <MenuItem>
                                                                <a className="hand" onClick={e => this.RemoveDocument(this.state.data.document.id)}>حذف سند</a>
                                                            </MenuItem>
                                                        </Menu>
                                                    </Dropdown>
                                                ) :
                                                (
                                                    <div className="me-2" style={{ display: 'inline-flex' }}>

                                                        <a className="btn btn-primary " onClick={e => this.TemporaryAccountClosingDocument()}>
                                                            <em className="icon ni ni-download-cloud"></em>
                                                            <span>سند بستن حساب های موقت</span>
                                                        </a>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="nk-block">
                            <div className="card card-bordered card-stretch">
                                <div className="card-inner-group">
                                    <div className="data-table-container-wrapper" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', overflow: 'hidden' }}>
                                        <div
                                            onDragOver={this.onDragOver}
                                            onDrop={() => this.onDrop('items1')}
                                            className="scrollable-box"
                                        >
                                            <div className="mb-3" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <h5>لیست حساب ها</h5>
                                                <li onClick={this.exploreClosing}>
                                                    <NavLink to="/closingdocument" className="btn btn-primary">
                                                        <em className="icon ni ni-download-cloud"></em>
                                                        <span>دریافت حساب ها</span>
                                                    </NavLink>
                                                </li>
                                            </div>
                                            <ul>{this.renderList(this.state.items1, 'items1')}</ul>
                                        </div>

                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                            <button
                                                onClick={this.transferItems}
                                                className="btn btn-white btn-outline-light bi bi-arrow-left-circle-fill fs-1"
                                                style={{ margin: '10px', alignSelf: 'center' }}
                                            >

                                            </button>
                                            <button
                                                onClick={this.transferItemsBack}
                                                className="btn btn-white btn-outline-light bi bi-arrow-right-circle-fill fs-1"
                                                style={{ margin: '10px', alignSelf: 'center' }}
                                            >
                                            </button>
                                        </div>
                                        <div
                                            onDragOver={this.onDragOver}
                                            onDrop={() => this.onDrop('items2')}
                                            className="scrollable-box"
                                        >
                                            <div className="mb-3" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <h5>بستن حساب های موقت به :</h5>
                                                <div>
                                                    <AsyncSelect
                                                        cacheOptions
                                                        loadOptions={this.loadAccountOptions}
                                                        defaultOptions
                                                        onInputChange={this.handleInputChange}
                                                        onChange={this.handleSelectChange}
                                                        placeholder="جستجوی حساب معین"
                                                        styles={{
                                                            control: (base) => ({
                                                                ...base,
                                                                minHeight: 30,
                                                                height: 35,
                                                                fontSize: 10,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                width: '200px' // تنظیم عرض بزرگتر
                                                            }),
                                                            menu: (base) => ({
                                                                ...base,
                                                                fontSize: 10
                                                            }),
                                                            singleValue: (base) => ({
                                                                ...base,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                whiteSpace: 'normal',
                                                                textOverflow: 'initial'
                                                            }),
                                                            indicatorSeparator: () => ({ display: 'none' }),
                                                            dropdownIndicator: () => ({ display: 'none' })
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <ul>{this.renderList(this.state.items2, 'items2')}</ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>}

                    {activeTab === 'document-final' && <div>
                            < DocumentFinal />
                    </div>}
                    {activeTab === 'document-close-annual' && <div>
                        < CreateClosingDocument />
                    </div>}

                </div>



            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {/*this.isEmptyAnnualsOrCompanies(this.state.data.global) ? this.renderNoCompanyOrAnnualRegister() :*/ this.renderForm()}

                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}